<div class="bmc-connect-connectors">
    <h5>{{'CONNECTORS.DESCRIPTION' | translate}}</h5>

    <div class="bmc-connectors">
        <div class="bmc-connectors__list">
          <h4 class="bmc-connectors__list__title">{{'CONNECTORS.TITLE_LIST' | translate}}</h4>
          <ul class="bmc-connectors-list">
            <li *ngFor="let connectorType of connectorsType">
              <div class="bmc-connectors-list__item"
                    (click)="connectorType.isExpanded = !connectorType.isExpanded">
                <div class="bmc-connectors-list__item__text bz-flex">
                  <bzg-icon [nameIcon]="'icon-bizagi'" [size]="16" [fill]="'none'"></bzg-icon>
                  <span class="bmc-connectors-name">{{connectorType.displayName}}</span>
                </div>
                <div>
                  <span class="bmc-connectors-version">V {{connectorType.version}}</span>
                  <bzg-icon [nameIcon]="connectorType.isExpanded ? 'arrow-up' : 'arrow-down'" [size]="14"></bzg-icon>
                </div>
              </div>
              <ul *ngIf="connectorType.isExpanded && connectorType.connectors.length" [@bzgSlideDown]>
                <li class="bmc-connectors-sublist"
                    *ngFor="let connector of connectorType.connectors" (click)="selectConnector(connectorType, connector)"
                    [ngClass]="{'bz-color-bg--theme-100': selectedConnector && (selectedConnector.id === connector.id || selectedConnector.parentId === connector.id)}">
                  <span class="">{{connector.displayName}}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        
        <div class="bmc-connectors-config">
            <div class="bmc-connectors-config__loading" *ngIf="isBusy">
              <bz-loading [size]="'xl'"></bz-loading>
            </div>
            <div class="bmc-connectors-config__container " *ngIf="selectedConnector && !isBusy">
                <connectors-interface #connectorsInterface [description]="selectedConnectorDescription" 
                                      [displayName]="selectedConnectorDisplayName" 
                                      [selectedConnectorType]="selectedConnectorType"
                                      [metadata]="metadata"
                                      [selectedConnector]="selectedConnector" *ngIf="selectedConnectorType.type === 'InterfaceConnector' && selectedConnector.type !== 'ConnectorConfiguration'">
                </connectors-interface>
                <connectors-sap #connectorsSap [name]="selectedConnectorName"
                                [displayName]="selectedConnectorDisplayName" 
                                [selectedConnectorType]="selectedConnectorType"
                                [properties]="metadata.sap"
                                (testConnectionEvent)="TestConnection()"
                                [selectedConnector]="selectedConnector" *ngIf="selectedConnectorType.type === 'Connector' && selectedConnector.type === 'ConnectorConfiguration'"></connectors-sap>
            </div>
            <div class="bmc-connectors-config__buttons" *ngIf="selectedConnector">

                
                <bzg-button-secondary class="bz-space--inline-m" (click)="cancelChanges()">
                    {{ 'GLOBAL.CANCEL' | translate }}
                </bzg-button-secondary>
    
                <bzg-button-primary (click)="saveConnector()">
                    {{ 'GLOBAL.APPLY' | translate }}
                </bzg-button-primary>

                
            </div>
        </div>
    </div>
</div>
